import { TweenMax } from "gsap";
import App from "../../../vendor_core/core/src/App";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { UpdateAutoplayCommand } from "../../../vendor_core/core/src/commands/GameCommands";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import AutoplayModel from "../../../vendor_core/core/src/model/AutoplayModel";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import BuyFeatureModel from '../../../vendor_core/core/src/model/BuyFeatureModel';
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { State } from "../../../vendor_core/core/src/states/State";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import VendorModel from '../../../vendor_core/server/model/VendorModel';
import RelaxPOSTMessageController from '../../../vendor_core/server/RelaxPOSTMessageController';
import BBMultiplierController from '../controllers/BBMultiplierController';

export default class BBSpinStartState extends State {
    public enter(): void {
        super.enter();
        let layer = ViewManager.getLayer(DefaultLayers.Paylines).getCurrentScene()
        if (layer.getSubView("wildEffect")) {
            layer.removeSubView("wildEffect")
        }
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        reelGroup.hideLinesAndInfo(true);
        if (AutoplayModel.isAutoSpinActive()) {
            UIController.setState(UIStates.AUTO);
        } else {
            UIController.setState(UIStates.SPIN);
        }
        if (!SpinModel.isInFreespins()) {
            BBMultiplierController.resetMultipliers();
        }
        if (SpinModel.isInFreespins()) {
            CommandManager.execute(Commands.UPDATE_WIN);
        }
        // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").enableMask();
        if (
            SpinModel.isInFreespins()
            && SpinModel.freespinsNum !== 0
            && !SpinModel.freespins[Math.abs(SpinModel.freespinsNum - 6)].generations.find(gen => gen.winnings.length > 0)
            ) {
            TweenMax.delayedCall(1.3, () => this.startSpin())
        } else {
            this.startSpin();
        }
    }

    protected startSpin() {
        if (AutoplayModel.isAutoSpinActive()) {
            CommandManager.execute(Commands.DECREMENT_AUTOPLAY);
            UpdateAutoplayCommand();
        }

        if (SpinModel.isInFreespins() || BuyFeatureModel.hasBuyFeatureIsTriggered || VendorModel.inFreeGames) {

        } else {
            const balanceEnoughForBet = BetModel.subtractBet(BetModel.totalBet);
            if (!balanceEnoughForBet) {
                BetModel.insufficientBalance = true;
                return this.exit();
            }
        }


        if (!SpinModel.isInFreespins()) {
            RelaxPOSTMessageController.gameRoundStarted({
                balance: BetModel.balance,
            });
        }

        // if (!SpinModel.isInFreespins()) {
        // }

        if (AutoplayModel.isAutoSpinActive()) {
            App.timeline.add(TweenMax.delayedCall(App.config.autoSpinDelay, () => {
                // CommandManager.execute(Commands.CLEAR_WIN);
                this.initReel();
            }), App.timeline.time());
        } else {
            this.initReel();
        }
        SoundController.playSound(SoundVars.EFFECT_REEL_SPIN, false);
        // App.dispatcher.emit(GameEvents.LINES_BOX_UPDATE);


    }


    protected initReel() {
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as ReelGroup;
        reelGroup.spin();
        this.exit()
    }
}
